<template>
  <BaseModal ref="modal">
    <UiModalDialog
      class="mynote-import-modal"
      dialog-width="40rem"
    >
      <template #header>
        {{ ls({ ja: 'マイノートの選択', en: 'Select My Note' }) }}
      </template>
      <div class="jps-modal-content">
        <div>
          <div class="select-list">
            {{
              ls({
                ja: 'インポートするノートを選択してください',
                en: 'Select a note to import',
              })
            }}
          </div>
          <div class="notes">
            <button
              v-for="n in noteStore.list"
              :key="n.id"
              class="jps-button jps-fullwidth"
              @click="selectNote(n)"
            >
              {{ ls(n.title) }}
            </button>
          </div>
        </div>
      </div>
      <template #buttons>
        <button @click="modal.reject()">{{ ls(dapLangGlobal.cancel) }}</button>
      </template>
    </UiModalDialog>
  </BaseModal>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'
import type { BaseModal } from '#components'

const { ls } = useI18n()
const noteStore = useNoteStore()

interface Props {}
const props = withDefaults(defineProps<Props>(), {})

const modal = ref<InstanceType<typeof BaseModal>>()
const openAwait = async () => {
  return await modal.value.openAwait<CurationPartDefinition[]>()
}
defineExpose({ openAwait })

const selectNote = async (n) => {
  const note = await noteStore.getNote(n.id)
  modal.value.resolve(note.parts)
}
</script>

<style lang="scss">
.mynote-import-modal {
  .notes {
    button {
      margin-top: 0.25rem;
      margin-bottom: 0.25rem;
    }
  }
}
</style>
